// extracted by mini-css-extract-plugin
module.exports = {"loader":"classes_loader__KWvug","spin":"classes_spin__L4QDJ"};